/**
 * VIDEO MANIFEST
 *
 * Per-flow video overrides for the universal guided tour system.
 * Maps a flow `id` to a publicly reachable video URL. If a flow also declares
 * `video_url` in its YAML config, that value takes precedence.
 */

export interface VideoManifestEntry {
  videoUrl: string;
  durationSeconds?: number;
  thumbnailUrl?: string;
}

export type VideoManifest = Record<string, VideoManifestEntry>;

/**
 * Default manifest. Extend by module or import module-specific overlays
 * from `@/config/guided-tours/[module]/videos`.
 */
export const defaultVideoManifest: VideoManifest = {
  // Total Operations foundation videos
  'operations-welcome': {
    videoUrl: '/videos/tours/operations-welcome.mp4',
    durationSeconds: 90,
    thumbnailUrl: '/images/tours/operations-welcome-thumb.jpg',
  },
  'operations-dashboard': {
    videoUrl: '/videos/tours/operations-dashboard.mp4',
    durationSeconds: 120,
    thumbnailUrl: '/images/tours/operations-dashboard-thumb.jpg',
  },
  'operations-schedule': {
    videoUrl: '/videos/tours/operations-schedule.mp4',
    durationSeconds: 150,
    thumbnailUrl: '/images/tours/operations-schedule-thumb.jpg',
  },

  // Total Finance foundation videos
  'finance-welcome': {
    videoUrl: '/videos/tours/finance-welcome.mp4',
    durationSeconds: 85,
    thumbnailUrl: '/images/tours/finance-welcome-thumb.jpg',
  },
  'finance-invoicing': {
    videoUrl: '/videos/tours/finance-invoicing.mp4',
    durationSeconds: 180,
    thumbnailUrl: '/images/tours/finance-invoicing-thumb.jpg',
  },
};

export function getVideoManifestEntry(
  manifest: VideoManifest,
  flowId: string
): VideoManifestEntry | null {
  return manifest[flowId] || null;
}
